<template>
    <ClientOnly>
        <div class="w-full history-table mt-5 mb-10"
            :class="{
                'mobile-active': mobileActive,
            }"
        >
            <CasinoHistoryTabs
                class="mb-4"
                v-model="sNowTab"
                v-if="!mobileActive"
                :isMobileMode="isMobileMode"
                :mobileActive="mobileActive" 
                v-model:sSizePicker="sSizePicker"
                :gameName="'futuresGame'" 
            />
            <!--
                ↑ 上方的页签组件（选项卡）
                ================================================================== 
                ↓ 表格内容
            -->
            <div v-if="reduceHistoryList?.length"
                class="flex relative flex-col gap-2 w-full"
            >
                <button v-if="mobileActive"
                    class="mob-table-wrap__all"
                    :disabled="oPositionData_i.closingAll"
                    @click="fnCashAll"
                >
                    {{ $t('waves.AllCashOut') }} 
                </button>
                <!-- 列表头，伪 theader -->
                <!-- ↓ 这个元素的的一个类名被拿走了 “gap-2” 因为造成了表头与列无法对齐，且原站点也没有 gap 值 -->
                <div
                    class="w-full flex px-2 py-2 text-[11px] font-bold text-[#55657E] justify-around"
                >
                    <HeadersWavesActive
                        v-if="mobileActive"
                        :isMobileMode="true"
                        :tabName="sNowTab"
                    ></HeadersWavesActive>
                </div>
                <!-- 
                    ↑ 伪 theader 
                    ↓ 伪 tbody
                --> 
                <div class="gap-2 flex w-full" 
                    :class="{
                        [animateClass]: Boolean(animateClass),
                        'animation--shadow': sNowTab == HistoryTabsEnum.public, 
                    }"
                >
                    <!-- ↓ 表格“行” 组件外套 -->
                    <div class="w-full flex-nowrap font-semibold flex rounded-md min-h-[50px] items-center bg-[rgba(22,31,44,.8)] px-2 py-2 text-[#93ACD3] justify-around"
                        :class="{
                            'bold-row': history.bold,
                        }"
                        v-for="(history, idx) in reduceHistoryList"
                        :key="sNowTab + (history?._id || idx)" 
                        :test-mark="history?._id || `No ID`"
                    >
                        <!-- ↓ 表格的行组件 -->
                        <component
                            v-if="!oPositionData.loading && lists[sNowTab]?.bodyComponent" 
                            :is="lists[sNowTab].bodyComponent" 
                            :isMobileMode="isMobileMode" 
                            :key="sNowTab + (history?._id || idx)" 
                            v-bind:history="history"
                            :tabName="sNowTab"
                            @dialogControl="(oData) => fnDialogManager(oData, history)"
                            @openGameDetail="openGameDetail"
                        ></component>
                    </div>
                </div>
                <!-- ↓ 分页组件 -->
                <q-pagination 
                    class="mt-2 mx-auto"
                    v-if="showPageInfo" 
                    v-model="iCurPage"
                    :max="Math.ceil(iTotalRows / Number(sSizePicker))"
                    :max-pages="5"
                    direction-links
                    flat
                    color="grey"
                    active-color="primary"
                />
            </div>
            <!--
                ↑ 有数据时显示的表格
                | --------------------------------------- 
                ↓ 无数据所示专区（在 mobile + active 模式下不显示） 
            -->
            <div
                v-else-if="!mobileActive"
                class="m-auto flex justify-center flex-col items-center select-none"
            >
                <img class="w-[165px] h-[165px] select-none pointer-events-none"
                    src="~/assets/imgs/casino/no-data-image.webp"
                />
                <!-- ↑ 无数据的狗头 logo --> 
                <div class="text-[#55657e] font-medium">
                    {{ $t('Noinformation') }}
                </div>
                <!-- 
                    ↑ 提示没有数据
                    | 上下二选一 
                    ↓ 提示未登录
                --> 
                <!-- 
                <div class="tips-for-login"
                    v-else-if="isSpecialPageWithoutLogin"
                >
                    <em @click="globalStore.actions_loginDialogIsOpen(1)">
                        {{$t('Login')}}
                    </em>
                    {{$t('waves.Or01')}}
                    <em @click="globalStore.actions_loginDialogIsOpen(2)">
                        {{$t('Signup')}}
                    </em>
                    {{$t('waves.Or02')}}
                </div>
                -->
            </div>
        </div>
    </ClientOnly>
    <!--
        ↑ 以上是表格 
        ↓ 以下是一些窗口，在此承接子组件的一些弹出事件
        ↓ 禁止由子组件（表格行）自行弹出窗口，否则在行被移除时窗口表现异常，会出错 
    -->
    <!-- ↓ 确认平仓的输入框 -->
    <WavesCashOutConfirm
        :all="oDialogCenter.closeConfirm.all"
        v-model="oDialogCenter.closeConfirm.visible" 
        :fnCallback="fnDoCloseForConfirmDialog" 
    ></WavesCashOutConfirm>
    <!-- ↓ 用户信息 -->
    <CasinoHistoryModalUserProfile
        v-model="oDialogCenter.user.visible"
        :user-id="String(oDialogCenter.user.data.userId)" 
    />
    <!-- ↓ 游戏历史窗口（期货合约详情）--> 
    <CasinoHistoryModalGameDetali
        v-if="historyDetailShow"
        :historyDetail="historyDetail"
        :wavesFnCashOut="toCashOneOut"
    />
    <!-- ↓ 止盈止损管理窗口，需要使用 v-if 触发其内部的 onMounted  --> 
    <ProfitLossSetting 
        type="dialog"
        v-if="oDialogCenter.pnlSetting.visible"
        v-model="oDialogCenter.pnlSetting.visible" 
        :modalData="oDialogCenter.pnlSetting.data"
    ></ProfitLossSetting>
</template>

<script lang="ts" >
export default defineComponent({name: 'WavesBigTable'}); 
</script>

<script setup lang="ts">
import HeadersWavesActive from '~/components/Casino/History/Headers/WavesActive.vue';
import BodysWavesPublic from '~/components/Casino/History/Bodys/WavesPublic.vue';
import BodysWavesActive from '~/components/Casino/History/Bodys/WavesActive.vue';
import BodysWavesClosed from '~/components/Casino/History/Bodys/WavesClosed.vue';
import WavesCashOutConfirm from '@/pages/casino/futuresGame/_components/confirm.vue'; 
import ProfitLossSetting from '@/pages/casino/futuresGame/_components/profitLossSetting.vue'; 
// ↑ Vue 组件 ---------------------------------------------------------  
import { useJoinStateStore } from '~/stores/cansino/joinState'; 
import { useUserStore } from '~/stores/user'; 
import useGlobalStore from '@/stores/global'; 
// ↑ stores ------------------------------------------------------------- 
import type { WavesHistoryPlus } from '@/socket/game/dto/waves.dto';
import { HistoryTabsEnum } from '@/components/Casino/History/Tabs/ts/Tabs';
import {
    oPairsMap,
    oColorInfo, 
    oWavesContractStatus,
} from '@/pages/casino/futuresGame/ts/wavesData';
import {
    settingsState_f,
    fnSettingCenter_Ft,
    oPositionData_i, 
    oPositionCenter_yt, 
    chartState_r,
    oElementVisible, 
} from '@/pages/casino/futuresGame/ts/wavesControlCenter'; 
import { 
    getInfo4Rows,
    fnCalcROI_wL,
    fnGetPriceMoveRate4Coeff,
    calcActiveContractPnl, 
} from '@/pages/casino/futuresGame/ts/wavesFn'; 

const props = defineProps({
    mobileActive: {
        type: Boolean, // 移动端 Active 页专用 
    },
});

const globalStore = useGlobalStore();
const joinStateStore = useJoinStateStore(); 
const userStore = useUserStore(); 
// -------- ↑ stores -------------------------------- 
const route = useRoute(); 
const {theme} = useRuntimeConfig().public.tailwind;
const {sm} = theme.extend.screensInt;
// -------- ↑ 公共方法、接口、常量等 -------------------------------- 
// -------- ↓ 自建变量 --------------------------------  
const animateClass = ref('');

// ↓ 窗口管理中心 
const oDialogCenter = reactive({
    user:{
        visible: false,
        data: {} as WavesHistoryPlus,
    },
    pnlSetting:{ // 止盈止损管理窗口 
        visible: false,
        data: {} as WavesHistoryPlus, 
    },
    closeConfirm: { // 平仓确认窗口 
        visible: false, 
        all: false, 
        data: {} as WavesHistoryPlus,
    },
});

// ↓ waves 游戏数据 
const oPositionData = oPositionData_i; 
const oPositionCenter = oPositionCenter_yt(); 
const oSettingCenter = fnSettingCenter_Ft(); 
// ↓ 特殊页列表
// ↓ 这些页会显示分页器，而且仅为已登录用户显示数据  
const aPagesHaveToLogin = [ 
    HistoryTabsEnum.active, 
    HistoryTabsEnum.closed, 
];
// ↓ 没有分页器的页 
const aPagesWithoutPagination = [
    HistoryTabsEnum.leaderboard,
    HistoryTabsEnum.public,
];

// ↓ 游戏详情浮层
const historyDetailShow = ref(false)
const historyDetail = ref({})

// ===================================================================== 
// ====== ↑ 一般数据 ================================================ 
// ====== ↓ 计算值 ===================================================  
// =====================================================================  

// ↓ 当前页
const sNowTab = computed<HistoryTabsEnum>({
    get(){
        if (props.mobileActive){
            return HistoryTabsEnum.active; // 固定值 
        }
        return oPositionData.currentTab;
    },
    set(sNewTab){
        if (props.mobileActive){
            return;
        }
        oPositionCenter.setCurrentTab(sNewTab); // 如此原版记录到起来 
    },
});


// ↓进入小屏模式 ◆ 
const isMobileMode = computed(()=>{
    return globalStore.innerWidth <= sm.max; 
});

// ↓ 页码对象 
const oPagination = computed({
    get(){
        if (props.mobileActive){
            return oPositionData.mobPagination;
        }
        return oPositionData.pagination;
    },
    set(oPage){
        // ↓ 没有实际被调用 
        // fnSetPagination({ ...oPage });
    },
});

// ↓ 每页行数 
const sSizePicker = computed({
    get(){
        // 其它页可选择数量，leaderboard 页恒定显示10行数据 
        if (sNowTab.value === HistoryTabsEnum.leaderboard){
            return '10';
        }
        return String(oPagination.value.perPage); 
    },
    set(perPage){
        console.log("每页行数：", perPage);
        fnSetPagination({
            perPage: Number(perPage),
        });
    },
});

// ↓ 当前页
const iCurPage = computed({
    get(){
        if (aPagesWithoutPagination.includes(sNowTab.value)){
            // ↓ 恒定在第1页，也没有分页器  
            return 1;
        }
        return oPagination.value.page; 
    },
    set(page){
        console.log("当前页：", page);
        fnSetPagination({
            page: Number(page),
        });
    },
});

// ↓ 是否显示分页器 
const showPageInfo = computed(() => {
    const iTotal = (
        props.mobileActive
        ? oPositionData.mobTotals 
        : oPositionData.totals
    );
    const bResult = (
        aPagesHaveToLogin.includes(sNowTab.value) 
        && iTotal > oPagination.value.perPage 
    );
    return bResult;
});

// ↓ 提示未登录 
const isSpecialPageWithoutLogin = computed(() => { 
    const stopRequest = (
        userStore.isLoggedIn == false // 未登录 
        && 
        aPagesHaveToLogin.includes(sNowTab.value) 
    );
    return stopRequest;
});

// ↓ 显示【全部提现】按钮 
const showCashOutAll = computed(()=>{
    const activeShowing = (
        sNowTab.value === HistoryTabsEnum.active
        || props.mobileActive
    );
    const hasRows = lists.active.list.length > 0; 
    return activeShowing && hasRows; 
});

// ↓ 总行数 total  
const iTotalRows = computed(()=>{
    if (props.mobileActive){
        return oPositionData.mobTotals;
    }
    return oPositionData.totals;
});

// ↓ 这是最终显示在表格中的数据，
// ↓ 此数组长度按用户设定的 "Size" 呈现
const reduceHistoryList = computed(() => {
    const t01 = Date.now();
    // ↓ 目标行数据 
    const aTableRows = (()=>{
        if (props.mobileActive){
            return oPositionData.mobPositions;
        }
        return oPositionData.positions;
    })();
    // ↓ 应对数据加载中的页面表现 
    if (oPositionData.loading){ 
        const ts = Date.now();
        const {length = 3} = aTableRows; 
        const aEmptyRows = [...Array(length).keys()].map((idx) => {
            return {_id: ts + idx};
        });
        return aEmptyRows; 
    }
    const list = aTableRows.map(oHis => {
        const oResult = {
            ...oHis,
            // precision: oSettingCenter.getDecimalsByCurrency(oHis.pair),
            // oTypeColor: oColorInfo[oHis.type], // 买涨买跌的合约类型标记 
            // stateRealtime: oPositionData_i.oStates[oHis._id]?.state || '', 
        };
        if (oHis.state == oWavesContractStatus.active){
            const pnl = calcActiveContractPnl(oHis);
            const roi = fnCalcROI_wL({
                wager: oHis.wager,
                pnl,
            });
            Object.assign(oResult, {
                pnl,
                roi,
            });
        }
        // oResult.oPNLColor = (() => {
        //     if (oHis.pnl >= 0) { 
        //         return oColorInfo.green;
        //     }else if (oHis.pnl < 0){
        //         return oColorInfo.red;
        //     }
        //     return ''; // 默认颜色 
        // })();
        // oResult.oROIColor = (() => {
        //     if ((oHis.roi || 0) >= 0) { // 原版的 0% 显示为绿色 
        //         return oColorInfo.green;
        //     }
        //     return oColorInfo.red;
        // })();
        Object.assign(
            oResult,
            getInfo4Rows(oHis),
        );
        return oResult; 
    });
    // console.log(`表格行已经刷新-🅰️耗时：`, Date.now() - t01); 
    return list;
});

// =======================================================
// ====== ↑ computed 专区结束在此  ========================== 
// =======================================================

// 4张表格 
const lists = reactive({
    active: {
        key: HistoryTabsEnum.active,
        list: reduceHistoryList as any,
        bodyComponent: markRaw(BodysWavesActive),
    },
    closed: {
        key: HistoryTabsEnum.closed,
        list: reduceHistoryList as any,
        bodyComponent: markRaw(BodysWavesClosed),
    },
    public: {
        key: HistoryTabsEnum.public,
        list: reduceHistoryList as any,
        bodyComponent: markRaw(BodysWavesPublic),
    },
    leaderboard: {
        key: HistoryTabsEnum.leaderboard,
        list: reduceHistoryList as any,
        bodyComponent: markRaw(BodysWavesPublic),
    },
});

let aniTimer = null;
// ↓ 记录数据变更前的数量，页签变化时会被归零 
let oLengthRecord = {
    [HistoryTabsEnum.active]: 0,
    [HistoryTabsEnum.closed]: 0,
    [HistoryTabsEnum.public]: 0,
};

watch(
    reduceHistoryList, 
    (aNewList) => {
        const iLengthRecord = oLengthRecord[sNowTab.value] || 0;
        const {length: iNewRows} = aNewList.filter(cur => cur.timestamp);
        let showAnimation = (
            iLengthRecord > 0 // 之前的数据非空，才播放动画 
            && iNewRows > iLengthRecord
        );
        // console.log(`${sNowTab.value} 页播放动画？`, iLengthRecord, '=>', iNewRows); 
        oLengthRecord[sNowTab.value] = iNewRows;
        // ↓ 将数据长度记录起来，用于下次判断 
        // ↓ 最后按情况添加动画类名 
        if (showAnimation) {
            animateClass.value = 'animation--start';
            aniTimer = setTimeout(() => {
                animateClass.value = '';
            }, 500);
        }
    },
    { deep: true },
);

// 监听 tab 切换
watch(
    () => sNowTab.value,
    (newVal, oldVal) => {
        if (newVal === oldVal) return;
        console.log("到达页：", newVal); 
        animateClass.value = '';
        clearTimeout(aniTimer);
        [
            HistoryTabsEnum.active,
            HistoryTabsEnum.closed,
            HistoryTabsEnum.public,
        ].forEach(curKey => {
            oLengthRecord[curKey] = 0; // 归零 
        });
        if (isSpecialPageWithoutLogin.value){
            oPositionCenter.clearPositions(); 
            return;
        }
        fnLoad1stPage();
    },
);

// 监听“币种” 切换 
watch(
    () => oPositionData.selectedInstrument, 
    (newVal, oldVal) => {
        const hasChanged = newVal !== oldVal;
        const isTabRight = sNowTab.value == HistoryTabsEnum.leaderboard; 
        if ( !hasChanged || !isTabRight ) {
            return;
        }
        // console.log("切换到新币种了：", newVal); 
        fnLoad1stPage({
            selectedInstrument: newVal,
        });
    },
);

watch(
    oElementVisible,
    (oNew)=>{
        // ↓ 这是主表跳到 public 页的几个必要条件  
        const arr = [
            oNew.showTopActiveTable, // true 表示上方组件已经突现 
            props.mobileActive == false,
            sNowTab.value == HistoryTabsEnum.active,
        ];
        const toJump = arr.every(Boolean);
        if (!toJump) return;
        if (1 && import.meta.dev){
            console.log("顶部 Active 页已经显示 🔶 立即关闭下方的 Active 页："); 
            console.log(deepCopy(oNew)); 
            console.log(deepCopy(arr)); 
        }
        oPositionCenter.setCurrentTab(HistoryTabsEnum.public);
    },
);


// ===================================================================
// ==== ↑ watch 专区  ================================================ 
// ===================================================================

// ↓ 窗口可见性管理
const fnDialogManager = (
    oNewState,
    oHistory, // 某一条合约的数据，
) => { 
    // oDialogCenter 
    const aKeys = Object.keys(oNewState);
    const aValues = Object.values(oNewState);
    aValues.forEach(obj => {
        obj['data'] ??= oHistory;
    });
    // console.log(`窗口管理：${aKeys[0]}\n`, deepCopy(oHistory)); 
    Object.assign(
        oDialogCenter,
        oNewState,
    );
};

 /** 特殊游戏处理
     * futuresGame 打开游戏详情弹框
     */
const openGameDetail = (data)=>{
    historyDetailShow.value = true
    historyDetail.value = data
}

// ↓ 修改页码 
const fnSetPagination = (oNew) => {
    // 入参包含键：page, perPage, 
    if (props.mobileActive){
        oPositionCenter.setMobPagination(oNew); 
    }else{
        oPositionCenter.setPagination(oNew); 
    }
    oPositionCenter.setLoading(true); 
    oPositionCenter.getPositions({
        tabType: sNowTab.value,
        forMobile: props.mobileActive,
    });
}

// ↓ 加载“新页签” 的数据 
const fnLoad1stPage = (oParams={}) => {
    const forMobile = props.mobileActive; 
    oPositionCenter.setLoading(true); 
    // ↓ 页码复位，已查验，跳到新页后要加载第1页的数据 
    oPositionCenter.resetPagination(forMobile);
    oPositionCenter.clearTotalPositions(forMobile);
    if (sNowTab.value != HistoryTabsEnum.leaderboard){
        // ↓ 离开特定页时清空币种过滤  
        oPositionCenter.setSelectedInstrument('');
    }
    // console.log("开始加载“新页签” 的数据 ", ); 
    oPositionCenter.getPositions({
        tabType: sNowTab.value, 
        forMobile,
        ...oParams,
    });
}

// ----- ↓ 以下几个方法是平仓相关方法 --------------------------------- 

// ↓ 平仓所有项（用于表格上方的【提现按钮】） 
const fnCashAll = () => {
    if (settingsState_f.userSettings.confirmAllCashOut){
        oDialogCenter.closeConfirm.visible = true; 
        oDialogCenter.closeConfirm.all = true; 
        return;
    }else{
        oPositionCenter.closeAllPositions();
    }
}

// ↓ 在确认窗口中点击【确认按钮】时调用此方法执行平仓 
const fnDoCloseForConfirmDialog = ()=>{
    if (oDialogCenter.closeConfirm.all){
        oPositionCenter.closeAllPositions();
    }else{
        oPositionCenter.closePositionById({
            positionId: oDialogCenter.closeConfirm.data._id,
        });
    }
}

// ↓ 点击【详情窗口】中【提现按钮】时调用此方法
// ↓ 此时有可能直接平仓成功，也有可能仅弹出平仓确认窗口 
const toCashOneOut = (
    oContract:WavesHistoryPlus, 
) => {
    if (settingsState_f.userSettings.confirmCashOut){ 
        oDialogCenter.closeConfirm.visible = true; 
        oDialogCenter.closeConfirm.all = false; 
        oDialogCenter.closeConfirm.data = oContract; 
        return;
    }
    // ↓ 直接平仓 
    oPositionCenter.closePositionById({
        positionId: oContract._id,
    });
};

// ↓ 初始化表格数据
onMounted(async () => {
    const {hasLogged} = await getUserInfo();
    const forMobile = props.mobileActive;
    if (!forMobile && !hasLogged){ 
        // ↓ 未登录时，直接跳到 public 页，并会触发加载 
        oPositionCenter.setCurrentTab(HistoryTabsEnum.public); 
        return;
    }
    // ↓ 大表格位于下方时专用订阅（防止重复订阅） 
    // ↓ 先查有效合约，查不到之后跳到 public 页 
    // ↓ 即使查询到了，也会因为在移动屏幕时跳到 public 页 
    const res = await oPositionCenter.getPositions({ 
        tabType: HistoryTabsEnum.active, 
        forMobile,
    });
    if (forMobile) return;
    // console.log("加载首次查询 🩵🩵🩵：", deepCopy(res)); 
    const hasRows = res?.data?.count > 0;
    // ↓ 在移动端的时候需要无条件切换到 public 页 
    // ↓ 或在无数据时也切换 
    if (!hasRows || oElementVisible.value.showTopActiveTable) { 
        oPositionCenter.setCurrentTab(HistoryTabsEnum.public);
    }
});


onBeforeUnmount(()=>{
    // 当前组件的监听与启动都已经转移到了游戏入口文件中  
});

</script>


<style scoped lang="scss">
.mobile-active{
    margin: 5px auto 0px;
}

.historyContainer::after {
    content: '';
    background: linear-gradient(181deg, rgba(13, 19, 28, 0) 21.34%, #0d131c 99.18%);
    height: 254px;
    position: absolute;
    bottom: 0;
    left: 0;
    pointer-events: none;
    width: 100%;
}

.animation--start {
    animation: shuffle 0.5s ease-out;
}

.animation--start > :first-child {
    animation: fadeInOpacity 0.5s ease-out;
}

.animation--shadow {
    position: relative;
    &::after {
        background: linear-gradient(181deg, rgba(13, 19, 28, 0) 21.34%, #0d131c 99.18%);
        bottom: 0;
        content: '';
        height: 254px;
        left: 0;
        pointer-events: none;
        position: absolute;
        width: 100%;
        will-change: top, bottom, scroll-position;
    }
}

@keyframes shuffle {
    0% {
        transform: translateY(-50px);
    }
    to {
        transform: translateY(0px);
    }
}

@keyframes fadeInOpacity {
    0% {
        opacity: 0;
    }
    to {
        opacity: 0.75;
    }
}

// ↓ 【全部兑现】按钮 
.mob-table-wrap__all {
    color: var(--color_blue);
    font-size: 12px;
    font-weight: 600;
    letter-spacing: -.02em;
    line-height: 16px;
    margin-bottom: 0;
    margin-top: 0;
    position: absolute;
    right: 5px;
    top: 9px; 
}

.bold-row{
    background: var(--color_blue);
    &:deep(){
        .wave-amount,
        .up-down-icon{
            color: white !important; 
        }
        .wave-leverage{
            color: rgb(255,255,255,0.7) !important; 

        }
    }
}

.tips-for-login{
    color: var(--Background-Tertiary);
    font-size: 14px;
    font-weight: 500;
    em{
        color: var(--color_blue);
        cursor: pointer;
        margin: 0 3px;
    }
}
</style>


